/* eslint-disable */
import $ from 'jquery';
import React from 'react';
import { connect } from 'react-redux';
import Menu from './Menu';
import Sliders from '../Common/Slider';

import {
    HOME_PAGE_UNLOADED,
} from '../../constants/actionTypes';

const mapStateToProps = state => ({
    ...state.home,
    appName: state.common.appName,
    token: state.common.token,
    pageName: 'product'
});

const mapDispatchToProps = dispatch => ({
    onUnload: () =>
        dispatch({ type: HOME_PAGE_UNLOADED })
});
var pageName = "product";
class Product extends React.Component {
    constructor(props) {
        super(props);
        this.handleGetStartedClick = this.handleGetStartedClick.bind(this);
    }

    handleGetStartedClick(e) {
        this.props.history.push('/invite');
    }

    componentWillMount() {
    }
    componentDidMount() {
        document.getElementById("laneVisionGetStarted").addEventListener("click", this.handleGetStartedClick);

        var CONTAINER_ORIGINAL_WIDTH = $('#carouselContainer').css('width');
        var CONTAINER_ORIGINAL_HEIGHT = $('#carouselContainer').css('height');

        var CONTAINER1_ORIGINAL_WIDTH = $(window).width();
        var CONTAINER1_ORIGINAL_HEIGHT = $(window).height();

        var mobileHightAdj = 50;
        var mobileWidthAdj = 50;

        var resizePadding = 1;
        var mousehover = 0;

        var isPortrait = false;
        var isMobile = false;

        if (window.matchMedia("(orientation: portrait)").matches) {
            // you're in PORTRAIT mode

            isPortrait = true;
        }

        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i
            .test(navigator.userAgent)) {
            mousehover = 1;
            isMobile = true;
        } else {

            if (isPortrait == true) {
                $("#portrait-blocker").hide();
            }
        }
        //  if (isMobile == false) {
        $("#carouselContainer").css('width', CONTAINER_ORIGINAL_WIDTH);
        $("#carouselContainer").css('height', CONTAINER_ORIGINAL_HEIGHT);

        var screen = {
            left: 0,
            top: 0,
            width: 0,
            height: 0
        };

        screen.width = window.innerWidth;
        screen.height = window.innerHeight;
        var scaleTo = 1;

        screenresize(true);;

        $(window).resize(function () {
            screenresize(true);;
        });
        // }

        function screenresize(isonload) {
            var width = $(window).width();
            var height = $(window).height();

            var maxWidth = window.screen.width;
            var maxHeight = window.screen.height;

            if (resizePadding == 1) {
                maxHeight = maxHeight + (mobileHightAdj);
                maxWidth = maxWidth + (mobileWidthAdj);
            }

            var scaleTo;

            if (width >= maxWidth && height >= maxHeight) {
                scaleTo = 1;
            } else {
                scaleTo = Math.min(width / maxWidth, height / maxHeight);
            }

           // $('#carouselContainer').css({ "transform": "scale(" + scaleTo + ")" });

            var containerLeft = 0;
            if ($(window).width() < parseInt(CONTAINER_ORIGINAL_WIDTH.replace("px", ""))) {
                containerLeft = - (parseInt(CONTAINER_ORIGINAL_WIDTH.replace("px", "")) - $(window).width()) / 2;
                $('#carouselContainer').css('left', containerLeft + 'px');
            }

            // var containerTop = (height - (maxHeight * scaleTo)) / 2;

            if ($('.content-container').hasClass('active') === true) {
                $("#carouselContainer").css('width', CONTAINER1_ORIGINAL_WIDTH);
                $("#carouselContainer").css('height', CONTAINER1_ORIGINAL_HEIGHT);
            }
        }
    }
    componentWillUnmount() {
        // document.getElementById("laneVisionGetStarted").removeEventListener("click", this.handleGetStartedClick);
        // this.props.onUnload();
    }
    render() {
        return (
            <div >
                {/* <div className="navbarfix-top">
                    <Menu />
                </div> */}

                <div id="productSliders" className="sliderfix-bottom">
                    <Menu />
                    <Sliders pageName={this.props.pageName} />
                </div>
                <div id="productNavigation" className="outerwrapper">
                    <div className="innerwrapper">
                        <div className="inner-slide"><span>lanevision</span></div>
                        <div className="inner-slide active"><span>Products</span></div>
                        <div className="inner-slide"><span>strokevision</span></div>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Product);



// WEBPACK FOOTER //
// src/components/Home/Product.js